/* Shipping estimates use the current cart; never add/remove products to quote. */
document.addEventListener('click', async function(event) {
  const button=event.target.closest('[data-shipping-calculate]');
  if(!button) return;
  const box=button.closest('[data-v2-shipping]'), input=box.querySelector('input'), output=box.querySelector('[role="status"]');
  const zip=input.value.replace(/\D/g,'');
  if(zip.length!==8){output.textContent='Informe um CEP com 8 números.';input.focus();return;}
  const params=new URLSearchParams({'shipping_address[zip]':zip,'shipping_address[country]':'Brazil'});
  const base=box.dataset.cartUrl;
  button.disabled=true; output.textContent='Consultando opções de entrega…';
  try {
    const start=await fetch(base+'/prepare_shipping_rates.json?'+params,{method:'POST',headers:{Accept:'application/json'},signal:AbortSignal.timeout(12000)});
    if(!start.ok) throw new Error('shipping');
    let data=null;
    for(let attempt=0;attempt<8;attempt++){
      await new Promise(resolve=>setTimeout(resolve,1000));
      const response=await fetch(base+'/async_shipping_rates.json?'+params,{headers:{Accept:'application/json'},signal:AbortSignal.timeout(12000)});
      if(!response.ok)throw new Error('shipping');
      data=await response.json();if(data!==null)break;
    }
    if(!data)throw new Error('timeout');
    output.replaceChildren();
    if(!data.shipping_rates?.length){output.textContent='Não encontramos uma opção para este CEP. Confirme o endereço na finalização ou fale com a Veluna.';return;}
    for(const rate of data.shipping_rates){const line=document.createElement('p');const price=Number(rate.price);line.textContent=rate.name+' — '+(Number.isFinite(price)?price.toLocaleString('pt-BR',{style:'currency',currency:rate.currency||'BRL'}):'Consulte na finalização');output.append(line);}
  } catch(error){output.textContent='Não foi possível consultar agora. O frete será informado na finalização da compra.';}
  finally{button.disabled=false;}
});
